import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { SlackAuthorizeSchema, SlackDisconnectSchema, SlackStatusSchema } from '../schemas/slack';
import { headers } from './meta';

const slackKeys = {
	all: ['slack'] as const,
	status: () => [...slackKeys.all, 'status'] as const,
};

const slackPaths = {
	// Note: routes use /slack/ prefix (not /slack_connector/)
	status: () => '/slack/status',
	authorize: () => '/slack/authorize',
	disconnect: () => '/slack/disconnect',
};

export const useSlackStatus = (enabled = true) => {
	const http = useHttpClient();
	return useQuery({
		queryKey: slackKeys.status(),
		queryFn: async () => {
			const res = await http.get(slackPaths.status(), { headers });
			return SlackStatusSchema.parse(res.data);
		},
		enabled,
	});
};

export const useSlackAuthorize = () => {
	const http = useHttpClient();
	return useMutation({
		mutationFn: async (returnPath?: string) => {
			const res = await http.get(slackPaths.authorize(), {
				headers,
				params: returnPath ? { return_path: returnPath } : undefined,
			});
			return SlackAuthorizeSchema.parse(res.data);
		},
	});
};

export const useSlackDisconnect = () => {
	const http = useHttpClient();
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async () => {
			const res = await http.delete(slackPaths.disconnect(), { headers });
			return SlackDisconnectSchema.parse(res.data);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: slackKeys.all });
		},
	});
};
